let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8B8z5")).then(() => parcelRequire('cCp8H'));